<template>
	<template v-if="dossierDataStore.data.objectData.erfpacht">
		<PropertyRow label="Soort erfpacht">
			<OptionInput
				v-model="dossierDataStore.data.objectData.erfpacht.kind"
				class="text-sm"
				:options="[
					{ value: 'particulier', label: 'Particulier' },
					{ value: 'gemeente', label: 'Gemeentelijk' },
				]"
			/>
		</PropertyRow>

		<PropertyInput
			v-model="dossierDataStore.data.objectData.erfpacht.startDate"
			label="Ingangsdatum erfpacht"
			:value-type="ValueType.Date"
			input-class="w-[200px]"
			dd-class="text-sm"
		/>

		<PropertyRow label="Erfpacht eeuwigdurend?">
			<OptionInput
				v-model="dossierDataStore.data.objectData.erfpacht.eeuwigdurend"
				class="text-sm"
				:options="yesNoOptions"
			/>
		</PropertyRow>

		<PropertyInput
			v-if="
				dossierDataStore.data.objectData.erfpacht.endDate ||
				dossierDataStore.data.objectData.erfpacht.eeuwigdurend === false
			"
			v-model="dossierDataStore.data.objectData.erfpacht.endDate"
			label="Einddatum erfpacht"
			:value-type="ValueType.Date"
			input-class="w-[200px]"
			dd-class="text-sm"
		/>

		<PropertyRow label="Is de erfpacht afgekocht?">
			<OptionInput
				v-model="dossierDataStore.data.objectData.erfpacht.isAfgekocht"
				class="text-sm"
				:options="yesNoOptions"
			/>
		</PropertyRow>

		<PropertyRow
			v-if="
				dossierDataStore.data.objectData.erfpacht.eeuwigdurendAfgekocht !==
					undefined ||
				(dossierDataStore.data.objectData.erfpacht.eeuwigdurend === true &&
					dossierDataStore.data.objectData.erfpacht.isAfgekocht)
			"
			label="Eeuwigdurend afgekocht?"
		>
			<OptionInput
				v-model="
					dossierDataStore.data.objectData.erfpacht.eeuwigdurendAfgekocht
				"
				class="text-sm"
				:options="yesNoOptions"
			/>
		</PropertyRow>

		<PropertyInput
			v-if="
				dossierDataStore.data.objectData.erfpacht.afgekochtTot !== undefined ||
				(dossierDataStore.data.objectData.erfpacht.isAfgekocht &&
					(dossierDataStore.data.objectData.erfpacht.eeuwigdurend === false ||
						dossierDataStore.data.objectData.erfpacht.eeuwigdurendAfgekocht ===
							false))
			"
			v-model="dossierDataStore.data.objectData.erfpacht.afgekochtTot"
			label="Afgekocht tot"
			:value-type="ValueType.Date"
			input-class="w-[200px]"
			dd-class="text-sm"
		/>

		<PropertyInput
			v-if="
				dossierDataStore.data.objectData.erfpacht.afkoopsom !== undefined ||
				dossierDataStore.data.objectData.erfpacht.isAfgekocht
			"
			v-model="dossierDataStore.data.objectData.erfpacht.afkoopsom"
			label="Afkoopsom erfpacht"
			:value-type="ValueType.Currency"
			input-class="w-[200px]"
			dd-class="text-sm"
		/>

		<PropertyRow
			v-if="
				dossierDataStore.data.objectData.erfpacht.meefinancieren !==
					undefined || dossierDataStore.data.objectData.erfpacht.isAfgekocht
			"
			label="Erfpacht meefinancieren?"
		>
			<OptionInput
				v-model="dossierDataStore.data.objectData.erfpacht.meefinancieren"
				class="text-sm"
				:options="yesNoOptions"
			/>
		</PropertyRow>

		<PropertyRow
			v-if="
				dossierDataStore.data.objectData.erfpacht.canAfkopen !== undefined ||
				dossierDataStore.data.objectData.erfpacht.isAfgekocht === false
			"
			label="Kan de erfpacht afgekocht worden?"
		>
			<OptionInput
				v-model="dossierDataStore.data.objectData.erfpacht.canAfkopen"
				class="text-sm"
				:options="yesNoOptions"
			/>
		</PropertyRow>

		<PropertyInput
			v-if="
				dossierDataStore.data.objectData.erfpacht.canonYearly !== undefined ||
				dossierDataStore.data.objectData.erfpacht.isAfgekocht === false
			"
			v-model="dossierDataStore.data.objectData.erfpacht.canonYearly"
			label="Jaarlijkse canon"
			:value-type="ValueType.Currency"
			input-class="w-[200px]"
			dd-class="text-sm"
		/>
	</template>
</template>

<script setup lang="ts">
import { useDossierDataStore } from "@/store/useDossierDataStore";
import { ValueType } from "@/enums/ValueType";
import { yesNoOptions } from "@/models/inventarisation/income/loondienstOptions";

const dossierDataStore = useDossierDataStore();
</script>
